import { TaskOutcomeDataSchema } from "@erp/shared-types";
import { z } from "zod";

/**
 * Shared task output schema used by the task tools/steps (create_task,
 * generate_task, resolve_task, create_subtask, complete_task).
 *
 * The transaction-spine fields (type, parent, anchor, outcome) are optional
 * so pre-existing consumers of the original shape keep validating; handlers
 * built on `buildTaskOutput` populate them.
 */
export const taskOutputSchema = z.object({
  id: z.uuid(),
  title: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  priority: z.string(),
  assigneeType: z.string().nullable(),
  assigneeUserId: z.uuid().nullable(),
  assigneeAgentDefinitionId: z.uuid().nullable(),
  dueDate: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
  tags: z.array(z.string()).nullable(),
  createdAt: z.string(),
  taskTypeId: z.uuid().nullable().optional(),
  parentTaskId: z.uuid().nullable().optional(),
  anchorEntityType: z.string().nullable().optional(),
  anchorEntityId: z.uuid().nullable().optional(),
  outcome: z.string().nullable().optional(),
  outcomeReason: z.string().nullable().optional(),
  input: z.record(z.string(), z.unknown()).nullable().optional(),
  outcomeData: TaskOutcomeDataSchema.nullable().optional(),
  outcomeContractFingerprint: z.string().nullable().optional(),
});
